export const SearchIcon = {
    template: `
    <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-symbol">
        <path class="search-path" d="M6.633 12.9035C9.74402 12.9035 12.266 10.3815 12.266 7.27051C12.266 4.15949 9.74402 1.63751 6.633 1.63751C3.52198 1.63751 1 4.15949 1 7.27051C1 10.3815 3.52198 12.9035 6.633 12.9035Z" stroke="#2C2A29" stroke-width="2"/>
        <path class="search-path" d="M10.178 11.5765L13.964 15.3625" stroke="#2C2A29" stroke-width="2"/>
    </svg>
	`,
    name: 'SearchIcon'
}
